import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import toLower from 'lodash/toLower';
import Pagination from '@components/@core/Pagination';
import TaskHeader from '@components/@core/TaskHeader';
import TaskItem from '@components/@core/TaskItem';
import TaskEmptyList from '@components/TaskEmptyList';
import { inPage } from '~/services/util';

const Task = ({ className = '', title = '', data = [], completed }) => {
    const userIds = useSelector((state) => state.app.selectedEmployee.users);
    const selectedProject = useSelector((state) => state.manage.selectedProject);
    const [page, setPage] = useState(1);
    const [per, setPer] = useState(15);
    const after = { type: 'SELECTPROJECT_REQUEST', project: selectedProject, userIds };

    return (
        <div className={cx('card', className)}>
            <TaskHeader className="pb-2" title={title} />
            {data.length > 0 ? (
                data.map((task, index) => inPage(index, page, per) && <TaskItem key={task.id} task={task} after={after} completed={completed} />)
            ) : (
                <TaskEmptyList message={`No ${toLower(title)} to display.`} />
            )}
            <Pagination className="pagination px-0" current={page} per={per} total={Math.ceil(data.length / per)} pers={[]} onChange={(e) => setPage(e)} />
        </div>
    );
};

export default memo(Task);
